import useBreadcrumb from "../../core/hooks/useBreadcrumb";
import OrdemLocacaoForm from "../features/OrdemLocacaoForm";

export default function LocacaoCadastroView() {
  useBreadcrumb("Ordem de Locação/Cadastro");

  return <OrdemLocacaoForm />;
}
